export default {
  login: {
    url: '/userauth/oauth/token?username=:username&password=:password&roleId=:roleId&loginBy=:loginBy&grant_type=:grant_type&deviceId=:deviceId&deviceType=web&countryCode=0&timezone=:timezone',
    method: 'POST',
    data: {
      username: '',
      password: '',
      roleId: '',
      loginBy: 'email',
      grant_type: 'password',
      deviceId: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  forgotPassword: {
    url: '/admin/admin/forgotPassword',
    method: 'POST',
    data: {
      email: '',
      role: 1,
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  resetPassword: {
    url: '/admin/admin/resetPassword',
    method: 'POST',
    data: {
      newPassword: '',
      role: 1,
      token: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  createAdmin: {
    url: '/admin/admin/createAdmin',
    method: 'POST',
    data: {
      name: '',
      mobile: 1,
      email: '',
      active: true,
      city: '',
      country: '',
      roleId: 1,
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  orderStatistics: {
    url: '/admin/admin/getOrderStatistics',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllCustomers: {
    url: '/admin/customer/getAllCustomers?records=:records&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile&searchByLocation=:searchByLocation&logInUserId=:logInUserId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllAdmin: {
    url: '/admin/admin/getAllAdmin?records=:records&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  getAdminProfile: {
    url: '/admin/admin/getAdminProfile/:userId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllNotification: {
    url: 'admin/admin/getAllNotification/:userId?records=:record&pageNumber=:pageNumber',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllTransactionHistory: {
    url: 'admin/admin/getAllTransactionHistory/:userId?page=:page&size=:size',
    method: 'GET',
    data: {
      userId: '',
      page: '',
      size: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  deleteAdmin: {
    url: 'admin/admin/deleteAdmin/:userId/:loginUserId',
    method: 'PUT',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllAdminRole: {
    url: 'admin/admin/getAllAdminRole',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  updateAdminProfile: {
    url: 'admin/admin/editAdminDetail',
    method: 'PUT',
    data: {
      userId: '',
      name: '',
      email: '',
      country: '',
      city: '',
      roleId: '',
      active: '',
      mobile: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  pendingApprovals: {
    url: '/admin/admin/getPendingApprovals',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  siteStatistics: {
    url: '/admin/admin/getSiteStatistics',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getListOfCancelledRequests: {
    url: '/admin/admin/getListOfCancelledRequests',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllPAandDAPendingForApproval: {
    url: '/admin/deliveryAgent/getAllPAandDAPendingForApproval/:roleId?records=:records&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile&userId=:userId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllOrders: {
    url: '/admin/admin/getTotalOrders',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  // http://localhost:8711/admin/admin/getTotalOrders?pageNumber=1&records=10&searchKey=&sortBy=requestId&sortOrder=ASC
  getTotalOrders: {
    url: '/admin/admin/getTotalOrders?pageNumber=:pageNumber&records=:records&searchKey=:searchKey&sortBy=:sortBy&sortOrder=:sortOrder',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getCancelledOrders: {
    url: '/admin/admin/getListOfCancelledRequests?pageNo=:pageNumber&records=:records&searchKey=:searchKey&sortBy=:sortBy&sortOrder=:sortOrder',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getInTransitOrders: {
    url: '/admin/admin/getListOfInTransitRequests?pageNo=:pageNumber&records=:records&searchKey=:searchKey&sortBy=:sortBy&sortOrder=:sortOrder',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getCompletedOrders: {
    url: '/admin/admin/getListOfDeliveredRequests?pageNo=:pageNumber&records=:records&searchKey=:searchKey&sortBy=:sortBy&sortOrder=:sortOrder',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getOrderDetailByOrderId: {
    url: 'admin/admin/getOrderDetailByOrderId/:orderId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getListOfDeliveredRequests: {
    url: '/admin/admin/getListOfDeliveredRequests',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getListOfInTransitRequests: {
    url: '/admin/admin/getListOfInTransitRequests',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getListOfOpenRequests: {
    url: '/admin/admin/getListOfOpenRequests',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  deliveryAgentList: {
    url: '/admin/deliveryAgent/getAllDeliveryAgent?records=:records&pageNumber=:pageNumber&blockedDueToCancellationLimit=:blockedDueToCancellationLimit&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile&searchByLocation=:searchByLocation&logInUserId=:logInUserId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getCancellationDetail: {
    url: '/admin/admin/getCancellationDetail/:requestId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  processingAgentList: {
    url: '/admin/processingAgent/getAllProcessingAgent?records=:records&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile&searchByLocation=:searchByLocation',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getPackageCountForPA: {
    url: '/admin/processingAgent/getPackageCountForPA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getTotalOrderProcessedPA: {
    url: '/admin/processingAgent/getTotalOrderProcessed/:id?records=:records&pageNumber=:pageNumber',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getTotalOrdersForDA: {
    url: '/admin/deliveryAgent/getTotalOrdersForDA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  getOpenBidsForDA: {
    url: '/admin/deliveryAgent/getOpenBidsForDA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllTripsForDA: {
    url: '/admin/deliveryAgent/getAllTripsForDA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getDeliveryAgentDetail: {
    url: '/admin/deliveryAgent/getDeliveryAgentDetail/:orderId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  // GET /deliveryAgent/getOrderAndBidCountForDA/{daId}
  getSubmittedBidsForDA: {
    url: '/admin/deliveryAgent/getSubmittedBidsForDA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  // GET /deliveryAgent/getSubmittedBidsForDA/{daId}
  getOrderAndBidCountForDA: {
    url: '/admin/deliveryAgent/getOrderAndBidCountForDA/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  getAllPAandDAForApproval: {
    url: 'admin/deliveryAgent/getAllPAandDAForApproval/:roleId?records=:records&pageNumber=:pageNumber&sortBy=:sortBy&sortOrder=:sortOrder&searchByProfile=:searchByProfile&adminLoginId=:userId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  customerProfileDeliveryRequestFilter: {
    url: 'admin/customer/customerProfileDeliveryRequestFilter?customerId=:customerId&origin=:origin&destination=:destination&status=:status&from=:form&to=:to',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getProcessingAgentDetail: {
    url: '/admin/processingAgent/getProcessingAgentDetail/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  blockUnblockCustomer: {
    url: '/admin/admin/blockAndUnblockUser/:userId',
    method: 'PUT',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  deliveryAgentprofile: {
    url: '/admin/deliveryAgent/getDeliveryAgentDetail/:daId?logInUserId=:logInUserId',

    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  deliveryAgentprofileCount: {
    url: '/admin/deliveryAgent/getOrderAndBidCountForDA/:daId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  customerProfileDetail: {
    url: '/admin/customer/customerProfileDetail/:customerId?logInUserId=:logInUserId',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getTotalOrderProcessed: {
    url: 'admin/deliveryAgent/getTotalOrderProcessed/:id',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  customerProfileDeliveryRequestFilter: {
    url: `/admin/customer/customerProfileDeliveryRequestFilter?customerId=:id&origin=:origin&destination=:destination&status=:status&from=:from&to=:to`,
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getProcessingAgentList: {
    url: '/admin/processingAgent/getProcessingAgentList',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  approveDA: {
    url: '/admin/admin/approveUser/:userId/:kycApprovedByAdmin?verificationDetailsByAdmin=:verificationDetailsByAdmin',
    method: 'PUT',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  rejectDA: {
    url: '/admin/admin/rejectUser',
    method: 'PUT',
    data: {
      reasonForRejection: '',
      rejectionDetail: '',
      userId: '',
      docsResubmissionBlocked: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  readNotification: {
    //url: '/user/notification/readNotification/:notificationId',
    url: 'admin/admin/readNotificationByUser/:userId',
    method: 'PUT',
    data: {
      notificationId: '',
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getListOfCompletedOrdersToBePaid: {
    url: '/admin/admin/getListOfCompletedOrdersToBePaid?roleId=:roleId&pageSize=:pageSize&pageNo=:pageNo&searchKey=:searchKey&sortBy=:sortBy&sortOrder=:sortOrder&listFor=:listFor',
    method: 'GET',
    data: {
      roleId: '',
      pageNo: '',
      pageSize: '',
      searchKey: '',
      sortBy: '',
      sortOrder: '',
      listFor: '',
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getOrderDetailofOrderList: {
    url: '/admin/admin/getPaymentDetailOfAnOrder?orderId=:orderId&userId=:userId',
    method: 'GET',
    data: {
      orderId: '',
      userId: '',
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getSetting: {
    url: '/user/adminUser/transactionSetup',
    method: 'GET',
    data: {
      orderId: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  referralCommission: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      referralCommission: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  delivaCommission: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      delivaCommission: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  paymentCycle: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      paymentCycle: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  paCommission: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      paCommission: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  transferFunds: {
    url: '/admin/admin/transferAmount',
    method: 'POST',
    data: {
      userId: '',
      amount: '',
      deliveryRequestId: '',
      currency: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  transferAllFunds: {
    url: '/admin/admin/transferAllAmount',
    method: 'POST',
    data: {
      transferList: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  holdPayment: {
    url: 'admin/admin/holdUnholdTransfer?roleId=:roleId',
    method: 'POST',
    data: {
      orderId: '',
      hold: '',
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getStatusBasedList: {
    url: '/user/payment',
    method: 'POST',
    data: {
      order: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getReferralList: {
    url: '/admin/admin/getReferralList?userId=:userId&page=:page&size=:size&sortBy=:sortBy&sortOrder=:sortOrder',
    method: 'GET',
    data: {
      userId: '',
      page: '',
      size: '',
      sortBy: '',
      sortOrder: '',
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  deliveryRequestPickupRadius: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      deliveryRequestPickupRadius: 10,
      radiusUnit: '',
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  isTwilioOn: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      twilioOnTimeInHours: 0,
      isTwilioOn: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  country: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      country: [],
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  approveBankDetails: {
    url: '/admin/admin/approveUserBankDetail/:userId/:bankDetailsApprovedByAdmin',
    method: 'PUT',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  rejectBankDetails: {
    url: '/admin/admin/rejectBankDetails',
    method: 'PUT',
    data: {
      rejectionDetail: '',
      userId: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  addRoute: {
    url: '/user/route/addRoute',
    method: 'POST',
    data: {
      deliveryType: '',
      source: {},
      destination: {},
      userId: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  getRouteListing: {
    url: '/user/route/getRouteList?page=:page&size=:size&deliveryType=:deliveryType&source=:source&destination=:destination&isMyRoute=false&userId=:userId&orderBy=:orderBy&orderType=orderType&currentLatitude=:currentLatitude&currentLongitude=:currentLongitude',
    method: 'GET',
    data: {
      deliveryType: '',
      source: '',
      destination: '',
      currentLongitude: '',
      currentLongitude: '',
      userId: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  activeInactiveStatus: {
    url: '/user/route/activeInactive',
    method: 'PUT',
    data: {
      userId: '',
      routeId: '',
      active: true,
    },
  },
  getRouteDetails: {
    url: '/user/route/getRoute?routeId=:routeId',
    method: 'get',
    data: {
      userId: '',
      routeId: '',
      active: true,
    },
  },
  documentationType: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      documentationType: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  isFavouritedEnable: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      isFavouritedEnable: false,
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  routeSubscriptionLimit: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      routeSubscriptionLimit: '',
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  routeCreateLimit: {
    url: '/user/adminUser/addTransactionFrequency',
    method: 'POST',
    data: {
      routeCreateLimit: '',
      routeCreateInMonth: 0,
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  addReferral: {
    url: 'user/referralPromotion/addReferral',
    method: 'POST',
    data: {
      referralId: '',
      roleId: '',
      referralCondition: '',
      referralCount: '',
      deliveryRequestType: '',
      offerName: '',
      discountType: '',
      percentageDiscount: '',
      discountAmount: '',
      maxDiscountAmount: '',
      region: '',
      currency: '',
      description: '',
      code: '',
      imageUrl: '',
      discountApplicationType: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getReferral: {
    url: 'user/referralPromotion/getReferral?referralId=:referralId',
    method: 'GET',
    data: { referralId: '' },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllReferral: {
    url: 'user/referralPromotion/getAllReferral?page=:page&size=:size&orderBy=:orderBy&deliveryType=:deliveryType&searchKey=:searchKey&sortDirection=:sortDirection',
    method: 'GET',
    data: {
      // userId: '',
      page: '',
      size: '',
      orderBy: '',
      deliveryType: '',
      sortDirection: '',
      searchKey: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllNotificationType: {
    url: 'user/referralPromotion/getAllNotificationType',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  notificationActivate: {
    url: 'user/referralPromotion/notificationActivate',
    method: 'PUT',
    data: {
      referralId: '',
      type: '',
      active: '',
      notifications: [],
      notificationEnable: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  notificationActivatePromo: {
    url: 'user/referralPromotion/notificationActivate',
    method: 'PUT',
    data: {
      promoId: '',
      type: '',
      active: '',
      notifications: [],
      notificationEnable: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getActivateNotifications: {
    url: 'user/referralPromotion/getActivateNotifications?referralId=:referralId',
    method: 'GET',
    data: {
      referralId: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getActivateNotificationsPromo: {
    url: `user/referralPromotion/getActivateNotificationPromo?promoId=:promoId`,
    method: 'GET',
    data: {
      promoId: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllRole: {
    url: '/user/referralPromotion/getAllRole',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllDiscountType: {
    url: 'user/referralPromotion/getAllDiscountType',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllDiscountApplicationType: {
    url: 'user/referralPromotion/getAllDiscountApplicationType',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllDeliveryRequestType: {
    url: 'user/referralPromotion/getAllDeliveryRequestType',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  activeInactive: {
    url: 'user/referralPromotion/activeInactive?referralId=:referralId',
    method: 'PUT',
    data: {
      referralId: '',
      active: '',
      userId: '',
      type: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  activeInactivePromo: {
    url: 'user/referralPromotion/activeInactive?promoId=:promoId',
    method: 'PUT',
    data: {
      promoId: '',
      active: '',
      userId: '',
      type: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getUserListByReferralId: {
    url: 'user/referralPromotion/getUserListByReferralId?referralId=:referralId&page=:page&size=:size&search=:search',
    method: 'GET',
    data: {
      referralId: '',
      page: '',
      size: '',
      search: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  // PROMO APIS
  getAllPromo: {
    url: 'user/referralPromotion/getAllPromo?page=:page&size=:size&orderBy=:orderBy&deliveryType=:deliveryType&searchKey=:searchKey&sortDirection=:sortDirection',
    method: 'GET',
    data: {
      page: '',
      size: '',
      orderBy: '',
      deliveryType: '',
      sortDirection: '',
      searchKey: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getPromo: {
    url: '/user/referralPromotion/getPromo?promoId=:promoId',
    method: 'GET',
    data: {
      promoId: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getUserListByPromoId: {
    url: 'user/referralPromotion/getUserListByPromoId?promoId=:promoId&page=:page&size=:size&search=:search',
    method: 'GET',
    data: {
      promoId: '',
      page: '',
      size: '',
      search: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  // Promotion Create Api
  addPromo: {
    url: 'user/referralPromotion/addPromo',
    method: 'POST',
    data: {
      code: '',
      countOfUsageLimits: 0,
      currency: '',
      deliveryDuration: null,
      deliveryDurationUnit: null,
      deliveryRequestType: '',
      description: '',
      discountApplicationType: null,
      discountType: null,
      geolocationBasedPromotions: '',
      imageUrl: '',
      maxDiscountAmount: null,
      minimumOrderAmount: null,
      noOfDelivery: null,
      occasions: null,
      offerName: '',
      otherOccasions: '',
      percentageDiscount: 0,
      promoDiscountType: null,
      promotionEndDate: '',
      promotionEndTime: '',
      promotionStartDate: '',
      promotionStartTime: '',
      promoId: null,
      recurringPromotions: null,
      region: '',
      roleId: 0,
      selectOccasions: null,
      stackableDiscounts: true,
      targetAudience: [''],
      usageFrequency: null,
      usageLimits: null,
      userCategory: null,
      details: '',
      redeem: '',
    },
  },
  addSenderPromo: {
    url: 'user/referralPromotion/addPromo',
    method: 'POST',
    data: {
      code: '',
      countOfUsageLimits: 0,
      currency: '',
      // deliveryDurationUnit: null,
      // deliveryDuration: '',
      deliveryRequestType: '',
      description: '',
      discountApplicationType: null,
      discountType: null,
      geolocationBasedPromotions: '',
      imageUrl: '',
      maxDiscountAmount: 0.0,
      minimumOrderAmount: 0.0,
      noOfDelivery: 0,
      occasions: null,
      offerName: '',
      otherOccasions: '',
      percentageDiscount: 0,
      promoDiscountType: null,
      promotionEndDate: '',
      promotionEndTime: '',
      promotionStartDate: '',
      promotionStartTime: '',
      promoId: 0,
      recurringPromotions: null,
      region: '',
      roleId: 0,
      selectOccasions: null,
      stackableDiscounts: true,
      targetAudience: [''],
      usageFrequency: null,
      usageLimits: null,
      userCategory: null,
      details: '',
      redeem: '',
    },
  },
  getPromoDiscountType: {
    url: 'user/referralPromotion/getPromoDiscountType',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getUsageLimit: {
    url: 'user/referralPromotion/getUsageLimit',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getUsagefrequency: {
    url: 'user/referralPromotion/getUsagefrequency',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getSelectOccasions: {
    url: 'user/referralPromotion/getSelectOccasions',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getRecurringPromotions: {
    url: 'user/referralPromotion/getRecurringPromotions',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getUserCategory: {
    url: 'user/referralPromotion/getUserCategory',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getDeliveryDurationUnit: {
    url: 'user/referralPromotion/getDeliveryDurationUnit',
    method: 'GET',
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
};
